module.exports = __webpack_public_path__ + "img/close.5597a988.svg";